import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 7AEB6E6A-4B4E-42C3-9AB2-1F47FE1BD29B
 * name network-strength-1
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-1.svg
 * tags
 * - Cellphone / Phone 
 */
export const NetworkStrength1Icon = createSvgIcon(<><path d="M1,21H21V1M19,5.83V19H11V13.83" /></>, 'NetworkStrength1Icon');
export default NetworkStrength1Icon